export const isWebApp = () => window.PLATFORM === 'web';
